module.exports = __webpack_public_path__ + "img/Cross Icon - white.4cc35aac.svg";